"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.HEIGHT_REM = exports.HEIGHT = void 0;
// @ts-check
var variants = {
  light: 'light',
  dark: 'dark',
  blue: 'blue',
  yellow: 'yellow'
};
exports.variants = variants;
var HEIGHT = 1.5;
exports.HEIGHT = HEIGHT;
var HEIGHT_REM = "".concat(HEIGHT, "rem");
exports.HEIGHT_REM = HEIGHT_REM;